import { Component, OnInit,ViewEncapsulation } from '@angular/core';
import {NavigationEnd, Router, NavigationStart, NavigationCancel} from '@angular/router';

@Component({
  selector: 'app-supported-formats',
  templateUrl: './supported-formats.component.html',
  styleUrls: ['./supported-formats.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class SupportedFormatsComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// C:/Work/Projects/OnlineParser/web2-ui/src/app/supported-formats/supported-formats.component.ts